import classcat from "classcat";
import React from "react";
import { useTranslation } from "react-i18next";

import { TranslationContext } from "@is/constants";

import css from "./InformationItem.module.css";

type Props = {
  title?: string;
  name?: string;
  id?: string;
};

const InformationItem = ({ title, name, id }: Props) => {
  const { t } = useTranslation(TranslationContext.Settings);

  return (
    <div className={css.container}>
      <div className="text-label-lg">{title}</div>
      <div className={css.infoContainer}>
        <div className={classcat(["text-label-lg", css.description])}></div>
        <div className={css.informationContainer}>
          {!!name?.length && (
            <div
              className={classcat([
                css.infoWrapper,
                { [css.separator]: !!name?.length && !!id?.length },
              ])}
            >
              <span className="text-label-lg">{t("Name")}</span>
              <span className={classcat([css.infoSubTitle, "text-label-lg"])}>
                {name}
              </span>
            </div>
          )}
          {!!id?.length && (
            <div className={css.infoWrapper}>
              <span className="text-label-lg">ID</span>
              <span className={classcat([css.infoSubTitle, "text-label-lg"])}>
                {id}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InformationItem;
